export interface ClientBrandDataResponse {
    DEFAULT: ClientBrandData;
    HMBCBS: ClientBrandData;
    HMBCBSDE: ClientBrandData;
    HMBCBSWV: ClientBrandData;
    HMBS: ClientBrandData;
    NEPA: ClientBrandData;
    PAGEID: string;
}

export interface ClientBrandData {
    businessTypeOptions: ClientBrandBusinessType[];
    pageModel?: any;
}

export interface ClientBrandBusinessType {
    label: string;
    value: string;
    selected?: boolean;
}

export interface ClientListResponse {
    baseMessage: any;
    groupList: ClientListData;
}

export interface ClientListData {
    associations: ClientData[];
    brokerpools: ClientData[];
    consortioms: ClientData[];
    groups: ClientData[];
    nonAffiliated: ClientData[];
    potentialAssociations: ClientData[];
    potentialBrokerpools: ClientData[];
    potentialConsortioms: ClientData[];
    potentialGroups: ClientData[];
    potentialNonAffiliated: ClientData[];
}

export interface ClientData {
    affiliationFrmDt: string;
    affiliationToDt: string;
    allGroupInidcator: string;
    allGroupInidcatorSA: string;
    bpdId: number;
    clientFrmDt: string;
    clientId: string;
    clientName: string;
    clientNumber: string;
    clientToDt: string;
    entityType: string;
    subgroupList?: ClientData[];
    subClientId?: string;
    subClientName?: string;
    subClientNumber?: string;
}

export const SUB_CLIENT_MAPPING = {
    A: 'associations',
    B: 'brokerpools',
    C: 'consortioms',
    N: 'nonAffiliated'
}